import React, {Component} from "react";
import {Helmet} from "react-helmet";
import screenshot from "../image/atman fish banner.png";

export default class MetaTags extends Component {
    render() {
        let companyName = "Chuang Xing Manufacturing Co., Ltd. ";
        if(window.location.pathname.toString() === "/catalogue"){
            companyName = "Catalogue - " + companyName;
        }

        let searchEngineTitle = companyName + "- wholesaling quality aquarium product";
        return (
            <React.Fragment>
                <Helmet>
                    <meta charSet="utf-8"/>
                    <title>{companyName}</title>
                    <link rel="canonical" href="http://chuangxing.com.hk/"/>
                    <meta name="description" content="Chuang Xing aquarium products have won worldwide recognition for its superior quality and service,
          which include glass aquarium, air pump, water pump, internal & external filter, LED light, heater,
          aquarium accessory and pet cage. It incorporates multiple well-established brands such as Atman,
          ViaAqua, Champion and Atec. They are acknowledged by the consumer for unique and excellent quality.
            "
                    />
                    <meta property="og:locale" content="en_HK"/>
                    <meta property="og:locale:alternate" content="zh_HK"/>
                    <meta property="og:locale:alternate" content="en_US"/>
                    <meta property="og:locale:alternate" content="en_AU"/>
                    <meta property="og:locale:alternate" content="en_CA"/>
                    <meta property="og:type" content="website"/>
                    <meta property="og:title"
                          content={searchEngineTitle}/>
                    <meta property="og:description" content="Chuang Xing aquarium products have won worldwide recognition for its superior quality and service,
          which include glass aquarium, air pump, water pump, internal & external filter, LED light, heater,
          aquarium accessory and pet cage. It incorporates multiple well-established brands such as Atman,
          ViaAqua, Champion and Atec. They are acknowledged by the consumer for unique and excellent quality.
            "/>
                    <meta property="og:url" content="http://chuangxing.com.hk/"/>
                    <meta property="og:site_name"
                          content={searchEngineTitle}/>
                    <meta property="og:image" content={screenshot}/>
                    <meta property="og:image:width" content="1264"/>
                    <meta property="og:image:height" content="846"/>
                    <meta name="twitter:card" content="summary_large_image"/>
                    <meta name="twitter:description" content="Chuang Xing aquarium products have won worldwide recognition for its superior quality and service,
          which include glass aquarium, air pump, water pump, internal & external filter, LED light, heater,
          aquarium accessory and pet cage. It incorporates multiple well-established brands such as Atman,
          ViaAqua, Champion and Atec. They are acknowledged by the consumer for unique and excellent quality."/>
                    <meta name="twitter:title"
                          content={searchEngineTitle}/>
                    <meta name="twitter:image" content={screenshot}/>
                </Helmet>
            </React.Fragment>
        );
    }
}